var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#E4151B",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 27.1183L18.7907 27.0981L31.7153 14.2215C32.2225 13.7113 32.5016 13.0338 32.5016 12.313C32.5016 11.5922 32.2225 10.9147 31.7153 10.4045L29.5872 8.26378C28.5727 7.24338 26.8028 7.24878 25.7965 8.25974L12.8691 21.139V27.1183ZM27.6898 10.1723L29.822 12.309L27.6791 14.4442L25.5509 12.3049L27.6898 10.1723ZM15.5528 22.2646L23.6441 14.2026L25.7723 16.3433L17.6823 24.4026L15.5528 24.4094V22.2646Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1837 32.4994H28.9695C30.4495 32.4994 31.6532 31.2887 31.6532 29.8V18.1004L28.9695 20.7999V29.8H14.4212C14.3863 29.8 14.3501 29.8135 14.3152 29.8135C14.2709 29.8135 14.2267 29.8013 14.181 29.8H10.1837V10.9036H19.3713L22.055 8.2041H10.1837C8.70363 8.2041 7.5 9.41482 7.5 10.9036V29.8C7.5 31.2887 8.70363 32.4994 10.1837 32.4994Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit_profile.67d7befa7ab08610661fc6b114950a5e.svg";
export { ForwardRef as ReactComponent };